/**
 * 1列を“継ぎ目なしの無限縦スクロール”にする
 * @param {HTMLElement} col        .col 要素
 * @param {"up"|"down"} dir        スクロール方向（視覚的）
 * @param {number} pxPerSec        速度(px/秒)
 */
function marqueeColumn(col, dir = 'down', pxPerSec = 40) {
  if (!col || col.dataset._marqueeInited) return;
  const inner = col.querySelector('.col-inner');
  if (!inner) return;

  // 重要：二重初期化防止
  col.dataset._marqueeInited = '1';

  // prefers-reduced-motion なら何もしない
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // 1) コンテンツを複製して可視領域の2倍以上の高さを確保（継ぎ目を消すため）
  const colH = col.clientHeight;
  const originals = Array.from(inner.children);
  let filledH = inner.scrollHeight;

  // .col-inner が空のときの保険
  if (originals.length === 0) return;

  while (filledH < colH * 2) {
    originals.forEach((n) => inner.appendChild(n.cloneNode(true)));
    filledH = inner.scrollHeight;
  }

  // 2) ループ距離：スクロール高さの半分を1サイクルに
  const loopDist = inner.scrollHeight / 2;

  // 3) アニメ時間 = 距離 / 速度
  const duration = loopDist / (pxPerSec || 40);

  // 4) 方向に応じた目標値（Modifiers でラップするので from は 0 でOK）
  const toY = dir === 'down' ? loopDist : -loopDist;

  // 5) 連続ラップ（継ぎ目なし）
  gsap.to(inner, {
    y: toY,
    ease: 'none',
    duration,
    repeat: -1,
    modifiers: {
      y: (v) => {
        const y = parseFloat(v) || 0;
        const wrapped = ((y % loopDist) + loopDist) % loopDist;
        return (dir === 'down' ? -wrapped : -wrapped) + 'px';
      },
    },
  });
}

const init = () => {
  const board = document.querySelector('.tile-board');
  if (!board) return;

  const cols = board.querySelectorAll('.col');
  cols.forEach((col) => {
    const dirAttr = (col.getAttribute('data-dir') || 'down').toLowerCase();
    const dir = dirAttr === 'up' ? 'up' : 'down';
    const speed = Number(col.getAttribute('data-speed')) || 40;
    console.log(speed);
    marqueeColumn(col, dir, speed);
  });
};

export default { init };
